var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c_button_border",domProps:{"innerHTML":_vm._s(_vm.msg)},on:{"click":_vm.actionClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }